<div class="light-blue-border-bottom dark-blue fw-bold flex justify-content-between pb-2">
  <div class="text align-self-center flex gap-2" [style]="{ 'font-size': textSize + 'px' }">
    <div data-test="navigate-back" class="back-btn" *ngIf="backButton" [routerLink]="this.backButtonUrl"><i class="fw-bold demo-icon icon-icons8-back"></i></div>
    <div class="align-self-center">{{ text }}</div>
  </div>
  <button class="btn button-blue align-self-center" *ngIf="showSaveButton" (click)="onSaveClicked.emit()" [disabled]="saveButtonDisabled || spinner" data-test="header-save-button">{{ spinner ? 'Saving... ' : 'Save'}} <app-loading-spinner *ngIf="spinner"></app-loading-spinner></button>
</div>
